module.exports = __webpack_public_path__ + "img/3.bb508d1a.jpg";